"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardViewConfig = exports.DashboardViewConfigProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DashboardViewConfigContext = react_1.default.createContext(undefined);
DashboardViewConfigContext.displayName = "DashboardViewConfigContext";
/**
 * @internal
 */
exports.DashboardViewConfigProvider = function (_a) {
    var children = _a.children, config = _a.config;
    return (react_1.default.createElement(DashboardViewConfigContext.Provider, { value: config }, children));
};
/**
 * @internal
 */
exports.useDashboardViewConfig = function () {
    return react_1.default.useContext(DashboardViewConfigContext);
};
//# sourceMappingURL=DashboardViewConfigContext.js.map